var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "waba-supsis-account-violation" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v(
        _vm._s(_vm.$t("auto.whatsappBusinessApiV2AccountViolationDetected"))
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "meta" }, [
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.event")))]),
        _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.channelId")))]),
        _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.violationType")))]),
        _vm._v(
          ": " +
            _vm._s(
              _vm.$_.get(_vm.activity, "payload.violation_info.violation_type")
            )
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("b", [_vm._v(_vm._s(_vm.$t("auto.accountId")))]),
        _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.entry[0].id"))),
      ]),
    ]),
    _vm._v(" "),
    _c("details", { staticClass: "raw" }, [
      _c("summary", [_vm._v(_vm._s(_vm.$t("auto.rawPayload")))]),
      _vm._v(" "),
      _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }